export enum Notifications {
  INFO = 'information',
  WARN = 'warning',
  SUCCESS = 'success',
  ERROR = 'error',
}
